<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card
          class="ma-3 col-sm-6"
          outlined
      >
        <v-card-title>Edit Outlet IP</v-card-title>
        <hr class="ma-1">
        <div class="col">
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-text-field
                v-model="outlet_ip.name"
                :rules="nameRules"
                label="Name"
                required
            ></v-text-field>

            <v-text-field
                v-model="outlet_ip.ip"
                :rules="ipRules"
                label="IP"
            ></v-text-field>

            <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4 font-weight-bold"
                @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    valid: true,
    nameRules: [
      v => !!v || 'Name is required',
    ],
    ipRules: [
      v => !!v || 'IP is required',
    ],
    breadcrumbsItems: '',
  }),
  props: ['outlet', 'outlet_ip'],
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        let outlet_id = this.outlet.id;
        axios.post('/outlet/' + this.outlet.id + '/ip/' + this.outlet_ip.id, {
          name: this.outlet_ip.name,
          ip: this.outlet_ip.ip,
        }).then(function (result) {
          window.location.href = '/outlet/' + outlet_id + '/edit';
        });
      }
    }
  },
  beforeMount() {
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: false,
        href: '/outlet/' + this.outlet.id + '/edit',
        link: true,
        text: this.outlet.name,
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: this.outlet_ip.name,
      },
    ];
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/OutletIPs/OutletIPEdit.vue